import axios from 'axios';
import qs from 'qs';
import store from '@/store';
import {localSt} from "@/store/localStorage.js";

//let host = 'http://wlp-rest.testing-only.de';
let host = '/';
//let host = '/';
const silksHost = ''; //https://wettstar-pferdewetten.de


export const instance = axios.create({
	baseURL: '/api',
	timeout: 30000,
	withCredentials: true,
	responseType: 'json',
	headers: {'content-type': 'application/x-www-form-urlencoded'},//TODO: migrate server to json format
	transformRequest: function (data, headers) {
		// Do whatever you want to transform the data

		if (typeof data === 'object' && headers['content-type'] !== 'application/json') {

			data.token = localSt.fetch('CSRFtoken');
			data = qs.stringify(data, {arrayFormat: 'brackets'});

		}else if(typeof data === 'undefined'){
			data = {
				token: localSt.fetch('CSRFtoken')
			};
			data = qs.stringify(data, {arrayFormat: 'brackets'});
		}

		return data;
	}
});

instance.interceptors.request.use(null, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

instance.interceptors.response.use( function (response) {

	//Update CSRF token
	if(response.data){
		if(response.data.content && response.data.content.last_token){
			//Get token from success response
			store.commit('setCSRFtoken', response.data.content.last_token);
		}else if( response.data.last_token ){
			//get token from ERROR response
			store.commit('setCSRFtoken', response.data.last_token);
		}
	}

	return response;
}, function(error){
	if((error && error.message !== 'recalculate_cancel_previous') || !error){
		store.dispatch('getMaintenanceStatus');
	}

	return Promise.reject(error);
});

//export const instance = instanceO;

export const instanceJSON = axios.create({
	baseURL: '/api',
	timeout: 30000,
	withCredentials: true,
	responseType: 'json',

});


//API requests list
export const hosts = {
	api: host,
	silks: silksHost
};
export const generalApi = {
	env: '/site',
	maintenance: '/site/maintenance',
	slider: '/slider'
};


export const registerApi = {
	register: '/user/register',
	cities: '/user/cities',
};

export const authApi = {
	auth: '/user/login', //GET( username, password )
	logout: '/user/logout',
	recover: {
		step1: '/user/recoverstep1',
		step2: '/user/recoverstep2',
		step25: '/user/recoverstep25',
		step3: '/user/recoverstep3'
	},
	refresh: '/user/islogin',
	data: '/user/data'

};

export const userApi = {
	bets: '/user/wagers',
	transactions: '/user/transactionhistory',
	data: '/user/data',
	exclude: '/user/closure',
	paymentTypes: '/payment/types',
	deposit: '/user/deposit',
	withdrawal: '/user/withdrawal'
};

export const raceApi = {
	timeline: '/meetings/',
	meeting: '/meetings/', // GET /meetings/{meetingId}/races/{raceId}
	race: '/races/',
	horse: '/horse/'
};

//Translation api
export const translationApi = {
	all: '/dictionary/'
};

//Content pages
export const contentPageApi = {
	page: '/page/',
	banners: '/banner/'
};

//Content pages
export const contactApi = {
	post: '/contact'
};

//Content pages
export const sellPointsApi = {
	get: '/sellpoint'
};

//Content pages
export const guideApi = {
	all: '/guide',
	details: '/guide/'
};

export const bettingApi = {
	calculate: '/betslip/calculate',
	send: '/betslip/send',
	cancel: '/betslip/cancel/'
};


